(function () {
    'use strict';

    if (window.__drtVariantImageSyncInitialized) {
        return;
    }

    window.__drtVariantImageSyncInitialized = true;

    function getProductJson(productContainer) {
        if (window.jQuery) {
            var jqueryData = window.jQuery(productContainer).data('json-product');

            if (jqueryData && typeof jqueryData === 'object') {
                return jqueryData;
            }

            if (typeof jqueryData === 'string') {
                try {
                    return JSON.parse(jqueryData);
                } catch (error) {
                    return null;
                }
            }
        }

        var rawData = productContainer.getAttribute('data-json-product');

        if (!rawData) {
            return null;
        }

        try {
            return JSON.parse(rawData);
        } catch (error) {
            return null;
        }
    }

    function syncQuickShopVariantImage(productContainer) {
        if (!productContainer) {
            return;
        }

        var variantSelect = productContainer.querySelector('select[name="id"]');

        if (!variantSelect) {
            return;
        }

        var productJson = getProductJson(productContainer);

        if (!productJson || !Array.isArray(productJson.variants)) {
            return;
        }

        var selectedVariantId = String(variantSelect.value);
        var selectedVariant = productJson.variants.find(function (variant) {
            return String(variant.id) === selectedVariantId;
        });

        if (!selectedVariant || !selectedVariant.featured_image) {
            return;
        }

        var variantImage =
            typeof selectedVariant.featured_image === 'string'
                ? selectedVariant.featured_image
                : selectedVariant.featured_image.src ||
                  selectedVariant.featured_image.url;

        if (!variantImage) {
            return;
        }

        var cardImage = productContainer.querySelector('.card-media img');

        if (!cardImage) {
            return;
        }

        cardImage.setAttribute('src', variantImage);
        cardImage.setAttribute('srcset', variantImage);

        if (cardImage.hasAttribute('data-src')) {
            cardImage.setAttribute('data-src', variantImage);
        }

        if (cardImage.hasAttribute('data-srcset')) {
            cardImage.setAttribute('data-srcset', variantImage);
        }
    }

    function resolveSelectedVariantFromInputs(productContainer, changedInput) {
        if (!productContainer || !changedInput) {
            return null;
        }

        var productJson = getProductJson(productContainer);

        if (
            !productJson ||
            !Array.isArray(productJson.variants) ||
            productJson.variants.length === 0
        ) {
            return null;
        }

        var formRoot =
            changedInput.closest('[data-quickshop]') ||
            changedInput.closest('form') ||
            productContainer;

        var sampleVariant = productJson.variants[0];
        var groupCount = Array.isArray(sampleVariant.options)
            ? sampleVariant.options.length
            : [
                  sampleVariant.option1,
                  sampleVariant.option2,
                  sampleVariant.option3
              ].filter(function (value) {
                  return value != null;
              }).length || 1;

        var selectedOptions = new Array(groupCount).fill(null);
        var changedGroup = changedInput.closest('[data-option-index]');
        var changedIndex = changedGroup
            ? parseInt(changedGroup.getAttribute('data-option-index'), 10)
            : 0;

        if (
            Number.isNaN(changedIndex) ||
            changedIndex < 0 ||
            changedIndex >= groupCount
        ) {
            return null;
        }

        selectedOptions[changedIndex] = changedInput.value;

        formRoot
            .querySelectorAll('[data-option-index]')
            .forEach(function (optionGroup) {
                var optionIndex = parseInt(
                    optionGroup.getAttribute('data-option-index'),
                    10
                );

                if (
                    Number.isNaN(optionIndex) ||
                    optionIndex < 0 ||
                    optionIndex >= groupCount ||
                    optionIndex === changedIndex
                ) {
                    return;
                }

                var checkedInput = optionGroup.querySelector(
                    '.single-option:checked, input[type="radio"]:checked, input[type="checkbox"]:checked'
                );

                if (checkedInput) {
                    selectedOptions[optionIndex] = checkedInput.value;
                    return;
                }

                var optionSelect = optionGroup.querySelector(
                    'select:not([name="id"])'
                );

                if (optionSelect) {
                    selectedOptions[optionIndex] = optionSelect.value;
                }
            });

        function normalize(value) {
            return String(value).trim();
        }

        return (
            productJson.variants.find(function (variant) {
                var variantOptions = Array.isArray(variant.options)
                    ? variant.options
                    : [variant.option1, variant.option2, variant.option3];

                for (var index = 0; index < groupCount; index += 1) {
                    if (
                        selectedOptions[index] == null ||
                        normalize(variantOptions[index]) !==
                            normalize(selectedOptions[index])
                    ) {
                        return false;
                    }
                }

                return true;
            }) || null
        );
    }

    function syncQuickShopVariantImageFromInputs(
        productContainer,
        changedInput
    ) {
        var selectedVariant = resolveSelectedVariantFromInputs(
            productContainer,
            changedInput
        );

        if (!selectedVariant || !selectedVariant.featured_image) {
            return;
        }

        var variantImage =
            typeof selectedVariant.featured_image === 'string'
                ? selectedVariant.featured_image
                : selectedVariant.featured_image.src ||
                  selectedVariant.featured_image.url;

        if (!variantImage) {
            return;
        }

        var cardImage = productContainer.querySelector('.card-media img');

        if (!cardImage) {
            return;
        }

        cardImage.setAttribute('src', variantImage);
        cardImage.setAttribute('srcset', variantImage);

        if (cardImage.hasAttribute('data-src')) {
            cardImage.setAttribute('data-src', variantImage);
        }

        if (cardImage.hasAttribute('data-srcset')) {
            cardImage.setAttribute('data-srcset', variantImage);
        }
    }

    document.addEventListener('change', function (event) {
        if (
            !event.target ||
            !event.target.matches('[data-quickshop] .single-option')
        ) {
            return;
        }

        var productContainer = event.target.closest('.product-item');

        syncQuickShopVariantImageFromInputs(
            productContainer,
            event.target
        );
    });

    function patchNativeQuickViewUpdateMedia() {
        if (!window.customElements) {
            return false;
        }

        var constructor =
            window.customElements.get('variant-quick-view-selects') ||
            window.customElements.get('variant-quick-view-radios');

        if (!constructor || !constructor.prototype) {
            return false;
        }

        var prototype = constructor.prototype;

        while (
            prototype &&
            !Object.prototype.hasOwnProperty.call(prototype, 'updateMedia')
        ) {
            prototype = Object.getPrototypeOf(prototype);
        }

        if (!prototype || typeof prototype.updateMedia !== 'function') {
            return false;
        }

        if (prototype.__drtNativeUpdateMediaPatched) {
            return true;
        }

        prototype.__drtNativeUpdateMediaPatched = true;
        prototype.__drtOriginalUpdateMedia = prototype.updateMedia;

        prototype.updateMedia = function (time) {
            this.__drtQuickViewMediaToken =
                (this.__drtQuickViewMediaToken || 0) + 1;

            var token = this.__drtQuickViewMediaToken;
            var selectedVariant = this.currentVariant;

            if (!selectedVariant || !selectedVariant.featured_media) {
                return;
            }

            var selectedVariantId = selectedVariant.id;
            var mediaId = selectedVariant.featured_media.id;
            var productId = this.dataset && this.dataset.product;

            if (!productId || !mediaId) {
                return;
            }

            var targetMedia = document.querySelector(
                '[data-media-id="' + productId + '-' + mediaId + '"]'
            );

            if (!targetMedia) {
                return;
            }

            var component = this;
            var delay = Math.max(0, Number(time) || 0);

            window.setTimeout(function () {
                if (component.__drtQuickViewMediaToken !== token) {
                    return;
                }

                if (
                    !component.currentVariant ||
                    String(component.currentVariant.id) !==
                        String(selectedVariantId)
                ) {
                    return;
                }

                if (
                    !component.isConnected ||
                    !document.documentElement.contains(targetMedia)
                ) {
                    return;
                }

                if (!window.jQuery) {
                    return;
                }

                window.jQuery(targetMedia).trigger('click');
            }, delay);
        };

        return true;
    }

    function initializeNativeQuickViewMediaPatch() {
        if (!window.customElements) {
            return;
        }

        patchNativeQuickViewUpdateMedia();

        [
            'variant-quick-view-selects',
            'variant-quick-view-radios'
        ].forEach(function (tagName) {
            window.customElements.whenDefined(tagName).then(function () {
                patchNativeQuickViewUpdateMedia();
            });
        });
    }

    var quickShopObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            if (
                mutation.type === 'attributes' &&
                mutation.attributeName === 'class' &&
                mutation.target.classList &&
                mutation.target.classList.contains('product-item') &&
                mutation.target.classList.contains('quickshop-popup-show')
            ) {
                syncQuickShopVariantImage(mutation.target);
            }
        });
    });

    function initializeVariantImageSync() {
        if (!document.body) {
            return;
        }

        quickShopObserver.observe(document.body, {
            subtree: true,
            attributes: true,
            attributeFilter: ['class']
        });

        document
            .querySelectorAll('.product-item.quickshop-popup-show')
            .forEach(function (productContainer) {
                syncQuickShopVariantImage(productContainer);
            });

        initializeNativeQuickViewMediaPatch();
    }

    if (document.readyState === 'loading') {
        document.addEventListener(
            'DOMContentLoaded',
            initializeVariantImageSync,
            { once: true }
        );
    } else {
        initializeVariantImageSync();
    }
})();
